import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useAxios from "../../../hook/useAxios";
import BreadCrumb from "../../Global/BreadCrumb";
import Loading from "../../Global/Loading";
import AddTreeNurseriesForm from "../AddTreeNurseries/AddTreeNurseriesForm";

const EditTreeNurseries = () => {
  const { id } = useParams<any>();
  const { fetchData: editTreeNursery, response: editResponse } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/nurseries/${id}/edit/`,
    "PUT",
    false,
    "",
    true,
    true
  );

  const {
    response: getEditResponse,
    fetchData: getTreeNursery,
    loading,
  } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/nurseries/${id}/edit/`,
    "GET",
    false,
    "",
    true,
    true
  );

  const { t } = useTranslation();

  useEffect(() => {
    getTreeNursery({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Tree nurseries.Edit tree nursery")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Navbar.Settings"), url: "" },
          {
            name: t("Tree nurseries.Tree nurseries"),
            url: "/setting/nurseries",
          },
          { name: t("Tree nurseries.Edit tree nursery"), url: "" },
        ]}
      />
      {loading ? (
        <Loading loading={true} />
      ) : (
        <div className="flex flex-wrap justify-between mt-4">
          <div className=" w-full h-fit lg:w-[49%] sc:w-[611px] bg-white rounded-md p-7 relative">
            <AddTreeNurseriesForm
              send={editTreeNursery}
              sendResponse={editResponse}
              getInfo={getEditResponse}
              textButton={t("Tree Species.Update")}
            />
          </div>
          <div className="w-full h-fit lg:w-[48%] sc:w-[559px] bg-white rounded-md p-8 mt-4 lg:mt-0">
            <img
              src="/img/Add incident.svg"
              alt="Edit incident"
              className="mt-4 ml-2 xl:ml-10"
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default EditTreeNurseries;
